import React, { useEffect, useState } from "react";
import { Header } from "../Core/Header";
import { Footer } from "../Core/Footer";
import { useDispatch, useSelector } from "react-redux";
import { checkOut, orderRazorpay, successRazorpay } from "../Services/Operations/ProductAPI";
import { emptyCart } from "../Redux/Cart-system";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const razorpay_key='rzp_test_cm51yZMIZQaYCB';

export const Checkout = () => {
  const dispatch=useDispatch()
  const navigate=useNavigate()

   const carts=useSelector((state)=>state.cart.cartItems)
   let cartdata=useSelector((state)=>state.cart)

   const [orderDetails,setOrderDetails]=useState({})
   const[paymentMode,setpaymentMode]=useState("ONLINE")

   let totalRate=0;

   useEffect(() => {

   const cal=()=> { 
   
    totalRate = carts.reduce((sum, item) => sum + item.rate, 0);
  }

   cal()
   }, [])
   
    

   const placeOrder=async(id)=>{
    // Logic to place order
    try {
      console.log("tatalrate",totalRate);
      
      const response=await checkOut({totalAmount:totalRate,
        grandTotal:cartdata.totalPrice,
        paymentMode: paymentMode,
        paymentStatus: "PAID",
        status: 1,
        razorpayPaymentId:id.id,
        district:"Kolkata",
        state:"West Bengal",
        pincode:"700001",
        city:"Kolkata",
        address:"Kolkata",
      })

        console.log(response);
        if(response.status===200){
          setOrderDetails(response.data.data)
          dispatch(emptyCart())
        //  handlePayment()
        }
        
    } catch (error) {
      console.log(error);

      
    }
   
    console.log("Order placed successfully",cartdata);
   }

   const handlePayment = async () => {
    try {
      // 1. Call your Spring Boot backend to create order
     let data = await orderRazorpay({amount:cartdata.totalPrice})

     console.log(data);
     

      const options = {
        key: razorpay_key, // replace with your Razorpay key
        amount: data.data.amount,// in paisa
        currency: "INR",
        name: 'RndSan Bussiness management',
        description: 'Test Transaction',
        order_id: data.data.razorpayOrderId, // order_id from backend
        handler:async function (response) {
          console.log(response); // contains payment_id, order_id, signature
          const credentials={
            razorpayOrderId: response.razorpay_order_id,
         razorpayPaymentId: response.razorpay_payment_id,
         razorpaySignature: response.razorpay_signature
          }
          // Optionally: call backend to verify payment
       const res= await successRazorpay(credentials)
          console.log(res);
          if(res.status===200){
            await placeOrder({id:res.data.id})
            toast.success("Payment Successful!")
            
          }
          
          // Redirect to home page after payment success
          
        },
        prefill: {
          name: 'Surajit',
          email: 'test@example.com',
          contact: '9999999999',
        },
        theme: {
          color: '#3399cc',
        },


  //        config: {
  //   display: {
  //     blocks: {
  //       card: {
  //         name: "Pay via Card",
  //         instruments: [
  //           {
  //             method: "card"
  //           }
  //         ]
  //       }
  //     },
  //      sequence: ["card", "upi", "wallet"],
  //     preferences: {
  //       show_default_blocks: false
  //     }
  //   }
  // }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (error) {
      console.error('Payment error:', error);
      alert('Something went wrong while processing payment.');
    }
  };


  return (
    <div>
    
      <Header/>
    
      <div
        className="modal fade"
        id="searchModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Search by keyword
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body d-flex align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  className="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span id="search-icon-1" className="input-group-text p-3">
                  <i className="fa fa-search" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div className="container-fluid page-header py-5">
        <h1 className="text-center text-white display-6">Checkout</h1>
        <ol className="Earscrumb justify-content-center mb-0">
          <li className="Earscrumb-item">
            <a href="#">Home</a>
          </li>
          <li className="Earscrumb-item">
            <a href="#">Pages</a>
          </li>
          <li className="Earscrumb-item active text-white">Checkout</li>
        </ol>
      </div>
      
      <div className="container-fluid py-5">
        <div className="container py-5">
          <h1 className="mb-4">Billing details</h1>
          <form action="#">
            <div className="row g-5">
              {/* <div className="col-md-12 col-lg-6 col-xl-7">
                <div className="row">
                  <div className="col-md-12 col-lg-6">
                    <div className="form-item w-100">
                      <label className="form-label my-3">
                        First Name<sup>*</sup>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <div className="form-item w-100">
                      <label className="form-label my-3">
                        Last Name<sup>*</sup>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
                <div className="form-item">
                  <label className="form-label my-3">
                    Company Name<sup>*</sup>
                  </label>
                  <input type="text" className="form-control" />
                </div>
                <div className="form-item">
                  <label className="form-label my-3">
                    Address <sup>*</sup>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="House Number Street Name"
                  />
                </div>
                <div className="form-item">
                  <label className="form-label my-3">
                    Town/City<sup>*</sup>
                  </label>
                  <input type="text" className="form-control" />
                </div>
                <div className="form-item">
                  <label className="form-label my-3">
                    Country<sup>*</sup>
                  </label>
                  <input type="text" className="form-control" />
                </div>
                <div className="form-item">
                  <label className="form-label my-3">
                    Postcode/Zip<sup>*</sup>
                  </label>
                  <input type="text" className="form-control" />
                </div>
                <div className="form-item">
                  <label className="form-label my-3">
                    Mobile<sup>*</sup>
                  </label>
                  <input type="tel" className="form-control" />
                </div>
                <div className="form-item">
                  <label className="form-label my-3">
                    Email Address<sup>*</sup>
                  </label>
                  <input type="email" className="form-control" />
                </div>
                <div className="form-check my-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="Account-1"
                    name="Accounts"
                    defaultValue="Accounts"
                  />
                  <label className="form-check-label" htmlFor="Account-1">
                    Create an account?
                  </label>
                </div>
                <hr />
                <div className="form-check my-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="Address-1"
                    name="Address"
                    defaultValue="Address"
                  />
                  <label className="form-check-label" htmlFor="Address-1">
                    Ship to a different address?
                  </label>
                </div>
                <div className="form-item">
                  <textarea
                    name="text"
                    className="form-control"
                    spellCheck="false"
                    cols={30}
                    rows={11}
                    placeholder="Oreder Notes (Optional)"
                    defaultValue={""}
                  />
                </div>
              </div> */}
              <div className="col-md-12 col-lg-6 col-xl-5">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Products</th>
                        <th scope="col">Name</th>
                        <th scope="col">Price</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                     {carts.length>0 ? carts.map((item)=>(
                      <tr>
                        <th scope="row">
                          <div className="d-flex align-items-center mt-2">
                            <img
                              src="Assets/img/ear.jpg"
                              className="img-fluid rounded-circle"
                              style={{ width: 90, height: 90 }}
                              alt
                            />
                          </div>
                        </th>
                        <td className="py-5">{item.name}</td>
                        <td className="py-5">₹{item.price}</td>
                        <td className="py-5">{item.quantity}</td>
                        <td className="py-5">₹{(item.price*item.quantity).toFixed(2)}</td>
                      </tr>
                     )):
                     <tr>
                        <th scope="row"></th>
                        <td className="py-5" />
                        <td className="py-5" >
                          <p className="mb-0 text-dark py-3">Cart is empty, add products to order</p>
                        </td>
                        <td className="py-5">
                         
                        </td>
                        <td className="py-5">
                          
                        </td>
                      </tr>
                      }
                      <tr>
                        <th scope="row"></th>
                        <td className="py-5" >
                          <p style={{fontSize:"20px"}}>Subtotal</p>
                        </td>
                        <td className="py-5" />
                        <td className="py-5"/>
                         
                        <td className="py-5">
                          <div className="py-3 border-bottom border-top">
                            <p className="mb-0 text-dark">${(useSelector((state)=>state.cart.totalPrice)).toFixed(2)}</p>
                          </div>
                        </td>
                      </tr>
                      {/* <tr>
                        <th scope="row"></th>
                        <td className="py-5">
                          <p style={{fontSize:"22px"}}>Shipping</p>
                        </td>
                        <td colSpan={3} className="py-5">
                          <div className="form-check text-start">
                            <input
                              type="checkbox"
                              className="form-check-input bg-primary border-0"
                              id="Shipping-1"
                              name="Shipping-1"
                              defaultValue="Shipping"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="Shipping-1"
                              style={{paddingLeft:"30px"}}
                            >
                              Free Shipping
                            </label>
                          </div>
                          <div className="form-check text-start">
                            <input
                              type="checkbox"
                              className="form-check-input bg-primary border-0"
                              id="Shipping-2"
                              name="Shipping-1"
                              defaultValue="Shipping"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="Shipping-2"
                              style={{paddingLeft:"30px"}}
                            >
                              Flat rate: $15.00
                            </label>
                          </div>
                          <div className="form-check text-start">
                            <input
                              type="checkbox"
                              className="form-check-input bg-primary border-0"
                              id="Shipping-3"
                              name="Shipping-1"
                              defaultValue="Shipping"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="Shipping-3"
                              style={{paddingLeft:"30px"}}
                            >
                              Local Pickup: $8.00
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row"></th>
                        <td className="py-5">
                          <p style={{fontSize:"22px"}}>
                            TOTAL
                          </p>
                        </td>
                        <td className="py-5" />
                        <td className="py-5" />
                        <td className="py-5">
                          <div className="py-3 border-bottom border-top">
                            <p className="mb-0 text-dark">${(useSelector((state)=>state.cart.totalPrice)).toFixed(2)}</p>
                          </div>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
                {/* <div className="row g-4 text-center align-items-center justify-content-center border-bottom py-3">
                  <div className="col-12">
                    <div className="form-check text-start my-3">
                      <input
                        type="checkbox"
                        className="form-check-input bg-primary border-0"
                        id="Transfer-1"
                        name="Transfer"
                        defaultValue="Transfer"
                      />
                      <label className="form-check-label" htmlFor="Transfer-1" style={{paddingLeft:"30px"}}>
                        Direct Bank Transfer
                      </label>
                    </div>
                    <p className="text-start text-dark">
                      Make your payment directly into our bank account. Please
                      use your Order ID as the payment reference. Your order
                      will not be shipped until the funds have cleared in our
                      account.
                    </p>
                  </div>
                </div> */}
                {/* <div className="row g-4 text-center align-items-center justify-content-center border-bottom py-3">
                  <div className="col-12">
                    <div className="form-check text-start my-3">
                      <input
                        type="checkbox"
                        className="form-check-input bg-primary border-0"
                        id="Payments-1"
                        name="Payments"
                        defaultValue="Payments"
                      />
                      <label className="form-check-label" htmlFor="Payments-1" style={{paddingLeft:"30px"}}>
                        Check Payments
                      </label>
                    </div>
                  </div>
                </div> */}
                {/* <div className="row g-4 text-center align-items-center justify-content-center border-bottom py-3">
                  <div className="col-12">
                    <div className="form-check text-start my-3">
                      <input
                        type="checkbox"
                        className="form-check-input bg-primary border-0"
                        id="Delivery-1"
                        name="Delivery"
                        defaultValue="Delivery"
                      />
                      <label className="form-check-label" htmlFor="Delivery-1" style={{paddingLeft:"30px"}}>
                        Cash On Delivery
                      </label>
                    </div>
                  </div>
                </div> */}
                {/* <div className="row g-4 text-center align-items-center justify-content-center border-bottom py-3">
                  <div className="col-12">
                    <div className="form-check text-start my-3">
                      <input
                        type="checkbox"
                        className="form-check-input bg-primary border-0"
                        id="Paypal-1"
                        name="Paypal"
                        defaultValue="Paypal"
                      />
                      <label className="form-check-label" htmlFor="Paypal-1" style={{paddingLeft:"30px"}}>
                        Paypal
                      </label>
                    </div>
                  </div>
                </div> */}
                <div className="row g-4 text-center align-items-center justify-content-center pt-4">
                  <button
                    type="button"
                    className="btn border-secondary py-3 px-4 text-uppercase w-100 text-primary"
                    onClick={handlePayment}
                  >
                    Place Order
                  </button>

                  
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
   
     <Footer/>
    </div>
  );
};
